import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2" }
const _hoisted_7 = { class: "w-full px-2 mt-3 items-end flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VisitanteSection = _resolveComponent("VisitanteSection")!
  const _component_StaffSection = _resolveComponent("StaffSection")!
  const _component_DisertanteSection = _resolveComponent("DisertanteSection")!
  const _component_PrensaSection = _resolveComponent("PrensaSection")!
  const _component_EquiposComunicacionSection = _resolveComponent("EquiposComunicacionSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/background.jpg`) + ')' })
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "flex flex-col items-center my-10" }, [
        _createElementVNode("img", {
          class: "object-contain w-12/12",
          src: _imports_0
        })
      ], -1)
    ]), 4),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-2 bg-[#044e7d]" }, null, -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-bold text-center text-xl" }, "Para comenzar seleccione el tipo de acreditación", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              name: "tipoAcreditacion",
              modelValue: _ctx.formData.tipoAcreditacion,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.tipoAcreditacion) = $event))
            }, {
              default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                _createVNode(_component_Select, {
                  onBlur: handleBlur,
                  "onUpdate:modelValue": handleChange,
                  "model-value": value,
                  class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}, "input-base"]),
                  placeholder: "Tipo de acreditacion",
                  options: _ctx.tiposAcreditaciones,
                  optionLabel: "descripcion"
                }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_ErrorMessage, { name: "tipoAcreditacion" })
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/credenciales",
              class: "border border-[#0f3449] text-[#0f3449] hover:bg-[#0f3449] hover:text-white px-4 py-2 rounded-md transition-all duration-200"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" YA ME ACREDITÉ ")
              ])),
              _: 1
            })
          ])
        ])
      ]),
      (_ctx.formData.tipoAcreditacion?.id === 'V')
        ? (_openBlock(), _createBlock(_component_VisitanteSection, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.formData.tipoAcreditacion?.id === 'S')
        ? (_openBlock(), _createBlock(_component_StaffSection, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.formData.tipoAcreditacion?.id === 'D')
        ? (_openBlock(), _createBlock(_component_DisertanteSection, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.formData.tipoAcreditacion?.id === 'P')
        ? (_openBlock(), _createBlock(_component_PrensaSection, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.formData.tipoAcreditacion?.id === 'E')
        ? (_openBlock(), _createBlock(_component_EquiposComunicacionSection, { key: 4 }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}